/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type featuredItemCarouselQueryVariables = {
    readonly listId: string;
    readonly after?: string | null;
    readonly first?: number | null;
};
export type featuredItemCarouselQueryResponse = {
    readonly list: {
        readonly errors: ReadonlyArray<{
            readonly created: unknown | null;
            readonly id: string;
            readonly location: string | null;
            readonly type: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly list: ({
            readonly __typename: string;
            readonly id?: string;
            readonly landingPageUrl?: string | null;
            readonly items?: {
                readonly pageInfo: {
                    readonly hasNextPage: boolean | null;
                } | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly listItem: {
                        readonly item: ({
                            readonly __typename: string;
                            readonly id?: string;
                            readonly name?: string | null;
                            readonly url?: string | null;
                            readonly title?: string | null;
                            readonly fullName?: string | null;
                        } & ({
                            readonly __typename: "Event";
                            readonly id: string;
                            readonly name: string | null;
                            readonly url: string | null;
                        } | {
                            readonly __typename: "OriginalContentStory";
                            readonly title: string | null;
                        } | {
                            readonly __typename: "Person";
                            readonly fullName: string | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
            } | null;
        } & ({
            readonly __typename: "FixedList";
            readonly id: string;
            readonly landingPageUrl: string | null;
            readonly items: {
                readonly pageInfo: {
                    readonly hasNextPage: boolean | null;
                } | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly listItem: {
                        readonly item: ({
                            readonly __typename: string;
                            readonly id?: string;
                            readonly name?: string | null;
                            readonly url?: string | null;
                            readonly title?: string | null;
                            readonly fullName?: string | null;
                        } & ({
                            readonly __typename: "Event";
                            readonly id: string;
                            readonly name: string | null;
                            readonly url: string | null;
                        } | {
                            readonly __typename: "OriginalContentStory";
                            readonly title: string | null;
                        } | {
                            readonly __typename: "Person";
                            readonly fullName: string | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
            } | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null;
    } | null;
};
export type featuredItemCarouselQuery = {
    readonly response: featuredItemCarouselQueryResponse;
    readonly variables: featuredItemCarouselQueryVariables;
};



/*
query featuredItemCarouselQuery(
  $listId: ID!
  $after: String
  $first: Int
) {
  list(id: $listId) {
    errors {
      created
      id
      location
      type
    }
    hasErrors
    list {
      __typename
      ... on FixedList {
        id
        landingPageUrl
        items(after: $after, first: $first) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            listItem {
              item {
                __typename
                ... on Event {
                  id
                  name
                  url
                }
                ... on OriginalContentStory {
                  title
                  id
                }
                ... on PodcastStory {
                  id
                  title
                }
                ... on Poster {
                  id
                  title
                }
                ... on Entity {
                  id
                  name
                }
                ... on Person {
                  id
                  fullName
                }
                ... on ArticleStory {
                  id
                  title
                }
                ... on BookStory {
                  id
                  title
                }
                ... on NewsletterStory {
                  id
                  title
                }
                ... on OnlineCourseStory {
                  id
                  title
                }
                ... on Node {
                  id
                }
                ... on SearchHit {
                  id
                }
                ... on Tag {
                  id
                }
              }
              id
            }
          }
        }
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "listId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "listId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "created",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v13 = [
  (v2/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v15 = [
  (v12/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "featuredItemCarouselQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": (v7/*: any*/),
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Event",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "OriginalContentStory",
                                    "selections": [
                                      (v12/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "PodcastStory",
                                    "selections": (v13/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Poster",
                                    "selections": (v13/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Entity",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v10/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Person",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "ArticleStory",
                                    "selections": (v13/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "BookStory",
                                    "selections": (v13/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "NewsletterStory",
                                    "selections": (v13/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "OnlineCourseStory",
                                    "selections": (v13/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "featuredItemCarouselQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": (v7/*: any*/),
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Event",
                                    "selections": [
                                      (v10/*: any*/),
                                      (v11/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "OriginalContentStory",
                                    "selections": (v15/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "PodcastStory",
                                    "selections": (v15/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Poster",
                                    "selections": (v15/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Entity",
                                    "selections": [
                                      (v10/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Person",
                                    "selections": [
                                      (v14/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "ArticleStory",
                                    "selections": (v15/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "BookStory",
                                    "selections": (v15/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "NewsletterStory",
                                    "selections": (v15/*: any*/)
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "OnlineCourseStory",
                                    "selections": (v15/*: any*/)
                                  }
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "featuredItemCarouselQuery",
    "id": null,
    "text": "query featuredItemCarouselQuery(\n  $listId: ID!\n  $after: String\n  $first: Int\n) {\n  list(id: $listId) {\n    errors {\n      created\n      id\n      location\n      type\n    }\n    hasErrors\n    list {\n      __typename\n      ... on FixedList {\n        id\n        landingPageUrl\n        items(after: $after, first: $first) {\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            listItem {\n              item {\n                __typename\n                ... on Event {\n                  id\n                  name\n                  url\n                }\n                ... on OriginalContentStory {\n                  title\n                  id\n                }\n                ... on PodcastStory {\n                  id\n                  title\n                }\n                ... on Poster {\n                  id\n                  title\n                }\n                ... on Entity {\n                  id\n                  name\n                }\n                ... on Person {\n                  id\n                  fullName\n                }\n                ... on ArticleStory {\n                  id\n                  title\n                }\n                ... on BookStory {\n                  id\n                  title\n                }\n                ... on NewsletterStory {\n                  id\n                  title\n                }\n                ... on OnlineCourseStory {\n                  id\n                  title\n                }\n                ... on Node {\n                  id\n                }\n                ... on SearchHit {\n                  id\n                }\n                ... on Tag {\n                  id\n                }\n              }\n              id\n            }\n          }\n        }\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '94007a4b3a16d5bdbce7efc342b32bbf';
export default node;
